export default __webpack_public_path__ + "static/media/Add-Address.bbfd2555.jpg";